module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"import":"Импортировать вакансии"}}')
  delete Component.options._Ctor
}
